<template>
  <div class="OpacitySlider">
    <label>Opacity: {{ value }}%</label>
    <input
      type="range"
      min="10"
      max="90"
      step="10"
      v-bind:value="value"
      v-on:input="setValue"
    />
  </div>
</template>

<script lang="ts">
import { GlobalMutations } from "@/store/mutations";
import { WBState } from "@/store/stateInterfaceType";
import WBComponent from "@/WBComponent";
import { Component } from "vue-property-decorator";

@Component
export default class LoadingSpinner extends WBComponent {
  value = 50;

  mounted() {
    this.value = (this.state as WBState).hud.opacity * 100;
  }

  setValue(e: Event) {
    this.value = parseFloat((e.target as HTMLInputElement).value ?? "50");
    GlobalMutations.setOpacity(this.$store.commit, this.value / 100);
  }
}
</script>

<style scoped lang="scss">
.OpacitySlider {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-size: var(--font-size-supplemental);
  height: calc(100% - var(--margin-tiny) * 2);
  margin: var(--margin-tiny);
}
</style>
